import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {environment} from '../../environments/environment';
import {AppConfigService} from "./config/app-config.service";

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isUserLoggedIn: boolean = false;
  portalAuth: string | undefined;
  priceAuthUrl: string | undefined;
  portalBo: string | undefined;

  loginStatusChange: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient, private appConfig: AppConfigService) {

    this.portalAuth = appConfig.getCommonConfig?.portalAuth;
    this.priceAuthUrl = appConfig.getCommonConfig?.priceAuthUrl;
    this.portalBo = appConfig.getCommonConfig?.portalBO;
  }

  changeLoginStatus(status: boolean) {
    this.isUserLoggedIn = status;
    this.loginStatusChange.next(this.isUserLoggedIn);
  }

  login(username: string, password: string): Observable<any> {
    return this.http.post(this.portalAuth + environment.signInPath, {
      username,
      password
    }, httpOptions);
  }

  getFeedUserRefreshToken(username: string, password: string): Observable<any> {
    return this.http.post(this.priceAuthUrl + environment.priceAuthRefreshPath, {
      username,
      password
    }, httpOptions);
  }

  getFeedUserAccessToken(refreshToken: string): Observable<any> {
    const params = new HttpParams().set('refresh_token', refreshToken);
    return this.http.get(this.priceAuthUrl + environment.priceAuthAccessPath, {params});
  }


}
